"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dataPointsToRenderPoints = function (charts, dataPointGroups) {
    return dataPointGroups.map(function (it, i) {
        var label = charts[i].id || "" + i;
        var index = i;
        var values = charts[i].values.map(function (it2, j) {
            var label2 = it2.label;
            var series = it[j];
            var points = it2.series.map(function (_, k) {
                return {
                    src: [k, j],
                    dest: [series[k][0], series[k][1]]
                };
            });
            return { label: label2, index: j, points: points };
        });
        var width = charts[i].width;
        var height = charts[i].height;
        return { label: label, index: index, width: width, height: height, values: values };
    });
};
exports.default = dataPointsToRenderPoints;
